import type { SessionDetailModalContent } from '@VelocitySquared/sunny16-content-dataobjects-cady/booking'

export const standardDetailModalFallback = {
  internalName: '',
  identifier: '',
  warningText: '',
  sectionHeading: '',
  sections: []
} as unknown as SessionDetailModalContent

export const simpleDetailModalFallback = {
  internalName: '',
  identifier: '',
  warningText: '',
  sectionHeading: '',
  sections: []
} as unknown as SessionDetailModalContent

export const basicPlusDetailModalFallback = {
  internalName: '',
  identifier: '',
  warningText: '',
  sectionHeading: '',
  sections: []
} as unknown as SessionDetailModalContent

export const basicMaxDetailModalFallback = {
  internalName: '',
  identifier: '',
  warningText: '',
  sectionHeading: '',
  sections: []
} as unknown as SessionDetailModalContent

export const basicDetailModalFallback = {
  internalName: '',
  identifier: '',
  warningText: '',
  sectionHeading: '',
  sections: []
} as unknown as SessionDetailModalContent

export const eliteDetailModalFallback = {
  internalName: '',
  identifier: '',
  warningText: '',
  sectionHeading: '',
  sections: []
} as unknown as SessionDetailModalContent

export const elitePlusDetailModalFallback = {
  internalName: '',
  identifier: '',
  warningText: '',
  sectionHeading: '',
  sections: []
} as unknown as SessionDetailModalContent

export const eliteUnlimitedDetailModalFallback = {
  internalName: '',
  identifier: '',
  warningText: '',
  sectionHeading: '',
  sections: []
} as unknown as SessionDetailModalContent

export const mostPopularDetailModalFallback = {
  internalName: '',
  identifier: '',
  warningText: '',
  sectionHeading: '',
  sections: []
} as unknown as SessionDetailModalContent

export const legacyDetailModalFallback = {
  internalName: '',
  identifier: '',
  warningText: '',
  sectionHeading: '',
  sections: []
} as unknown as SessionDetailModalContent
